<template>
  <div class="page">
    <h1>Question</h1>
    <PreOrP class="question" :text="conv.question"></PreOrP>
    <div v-if="!hasWritten && conv.withTemplate">
      <mdb-stepper
        simpleV
        :steps="StepperInfo"
        validation
        :validatedSteps="validatedSteps"
        @validate="validate"
        @submit="submit"
        class="stepper"
      >
        <template #1>
          <form ref="form-1">
            <div
              class="step-info"
            >Le contexte peut jouer un rôle dans le vécu de la situation. Comment vous sentiez-vous avant l'évènement de la question?</div>
            <mdb-alert color="warning">
              <mdb-icon far icon="frown-open" />Tu m'avais déjà énervé toute la journée.
            </mdb-alert>
            <mdb-alert color="success">
              <mdb-icon far icon="grin-alt" />Je sentais que j'étais plus sensible avec toi à cause du stress que j'ai en ce moment.
            </mdb-alert>
            <mdb-input :label="StepperInfo[0].name" type="textarea" :rows="6" v-model="texts[1]" />
          </form>
        </template>
        <template #2>
          <form ref="form-2">
            <div
              class="step-info"
            >Comment vous sentiez-vous pendant l'évènement de la question? Il n'y a pas de réalité, chacun a sa perception, et ses propres émotions.</div>
            <mdb-alert color="warning">
              <mdb-icon far icon="frown-open" />Je déteste quand tu fais ça.
            </mdb-alert>
            <mdb-alert color="success">
              <mdb-icon far icon="grin-alt" />Je me sens seul quand j'ai l'impression que tu ne te confies pas à moi.
            </mdb-alert>
            <mdb-input :label="StepperInfo[1].name" type="textarea" :rows="6" v-model="texts[2]" />
          </form>
        </template>
        <template #3>
          <form ref="form-3">
            <div
              class="step-info"
            >De quoi avez-vous besoin afin d'aller mieux? Idéalement, vous devriez pouvoir répondre à votre besoin par vous même. Si vous faites une demande à l'autre, gardez à l'esprit qu'il s'agit d'une demande, et que l'autre est tout à fait libre de l'accepter ou non.</div>
            <mdb-alert color="warning">
              <mdb-icon far icon="frown-open" />J'aimerais que tu sois parfait(e).
            </mdb-alert>
            <mdb-alert color="success">
              <mdb-icon far icon="grin-alt" />Ca m'aiderait que tu me préviennes avant de décider de tout changer, afin que je puisse m'y préparer mentalement.
            </mdb-alert>
            <mdb-input :label="StepperInfo[2].name" type="textarea" :rows="6" v-model="texts[3]" />
          </form>
        </template>
        <template #4>
          <form ref="form-4">
            <div
              class="step-info"
            >Qu'est ce qui est super actuellement? Il est bon de se rappeler, et de continuer à dire merci pour tout ce qui va bien.</div>
            <mdb-alert color="warning">
              <mdb-icon far icon="frown-open" />Merci pour tout !
            </mdb-alert>
            <mdb-alert color="success">
              <mdb-icon far icon="grin-alt" />J'ai vraiment adoré le regard que tu m'as lancé au début de la soirée. Je me suis senti(e) super important à tes yeux.
            </mdb-alert>
            <mdb-input :label="StepperInfo[3].name" type="textarea" :rows="6" v-model="texts[4]" />
          </form>
        </template>
        <template #5>
          <form ref="form-5" @submit.prevent="submit">
            <div
              class="step-info"
            >C'est le moment de rappeler à l'autre que la vie est belle, que nos sentiments sont toujours présents et forts.</div>
            <mdb-alert color="warning">
              <mdb-icon far icon="frown-open" />Ne rappelez pas les informations précédentes.
            </mdb-alert>
            <mdb-alert color="success">
              <mdb-icon far icon="grin-alt" />Laissez parler votre coeur.
            </mdb-alert>
            <mdb-input :label="StepperInfo[4].name" type="textarea" :rows="6" v-model="texts[5]" />
            <mdb-btn class="orange darken-1" rounded type="submit">Envoyer</mdb-btn>
          </form>
        </template>
      </mdb-stepper>
    </div>
    <div v-else-if="!hasWritten && !conv.withTemplate">
      <mdb-input label="Votre réponse" type="textarea" :rows="5" v-model="texts[1]" />
      <mdb-btn class="orange darken-1" rounded @click="submit">Envoyer</mdb-btn>
    </div>

    <div v-if="hasWritten" class="answers">
      <mdb-alert color="warning">
        <mdb-icon far icon="frown-open" />Ne jugez pas, ne vous défendez pas, les émotions ressenties ne sont pas débattables.
      </mdb-alert>
      <mdb-alert color="success">
        <mdb-icon far icon="grin-alt" />Lisez une fois avec le coeur, une fois avec la tête, puis parlez-en.
      </mdb-alert>
      <mdb-row>
        <mdb-col>
          <mdb-tabs
            :active="active"
            pills
            color="orange darken-1"
            card
            navClass="mb-4"
            :links="names"
            :content="answers"
          />
        </mdb-col>
      </mdb-row>
    </div>
    <InPageNav></InPageNav>
    <hr />
    <mdb-btn color="danger dark" @click="deleteConversation">Supprimer</mdb-btn>
  </div>
</template>

<script>
import { mdbStepper, mdbAlert, mdbIcon, mdbRow, mdbCol, mdbTabs } from "mdbvue";
import { mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
import InPageNav from "@/components/InPageNav";
import PreOrP from "@/components/PreOrP";
export default {
  name: "ConversationChat",
  components: {
    mdbStepper,
    mdbAlert,
    mdbIcon,
    mdbRow,
    mdbCol,
    mdbTabs,
    InPageNav,
    PreOrP
  },
  computed: {
    ...mapGetters("conversations", ["getConversation"]),
    ...mapState("conversations", ["userAnswers", "allAnswers"]),
    ...mapState("db", ["user"]),
    ...mapState("social", ["usersRef"]),
    conv: function() {
      return this.getConversation(this.$route.params.conversationId);
    },
    hasWritten: function() {
      return (
        this.conv.hasWritten && this.conv.hasWritten.includes(this.user.id)
      );
    },
    names: function() {
      let others = this.allAnswers.filter(doc => doc.id !== this.user.id);
      return [
        { text: "Votre réponse" },
        ...others
          .map(answer => this.usersRef[answer.id].displayName)
          .map(name => {
            return { text: name };
          })
      ];
    },
    answers: function() {
      let myAnswer = this.allAnswers.filter(doc => doc.id === this.user.id);
      let others = this.allAnswers.filter(doc => doc.id !== this.user.id);
      let mapFun;
      if (this.conv.withTemplate) {
        mapFun = l =>
          l.map(doc =>
            doc.answers
              .map(r => "<p>" + r.replace("\n", "<br />") + "</p>")
              .map(
                (r, i) =>
                  "<span class='answer-question'>" +
                  this.StepperInfo[i].name +
                  "</span><br />" +
                  r
              )
              .join("")
          );
      } else {
        mapFun = l =>
          l.map(doc =>
            doc.answers
              .map(r => "<p>" + r.replace("\n", "<br />") + "</p>").join("")
          );
      }
      if (others) return [...mapFun(myAnswer), ...mapFun(others)];
      else return mapFun(myAnswer);
    }
  },
  data() {
    return {
      texts: {},
      validatedSteps: {},
      StepperInfo: [
        { name: "Je me sentais déjà..." },
        { name: "Je me suis senti(e)..." },
        { name: "Je pense que j'ai besoin de..." },
        { name: "Je suis reconnaissant(e) pour..." },
        { name: "Je t'adore..." }
      ],
      active: 0
    };
  },
  watch: {
    conv: {
      immediate: true,
      handler: async function() {
        await this.$store.dispatch("conversations/bindUserAnswers", this.conv);
        if (!this.userAnswers || !this.userAnswers.answers) return;
        for (var i = 0; i < this.userAnswers.answers.length; i++)
          this.texts[i + 1] = this.userAnswers.answers[i];
        this.texts = { ...this.texts };
      }
    },
    answers: function(v) {
      if (v.length > 1) this.active = 1;
      else this.active = 0;
    }
  },
  methods: {
    validate(step) {
      if (this.texts[step] && this.texts[step].length > 0)
        this.validatedSteps[step] = true;
      else this.validatedSteps[step] = false;

      this.$store.dispatch("conversations/saveAnswers", {
        answers: Object.values(this.texts),
        isDone: false,
        conv: this.conv
      });
    },
    submit() {
      if (!this.conv.withTemplate && this.texts[1]) {
        console.log("no template");
      } else {
        for (var i = 1; i < this.StepperInfo.length + 1; i++) {
          if (!this.texts[i] || this.texts[i].length == 0) {
            console.log("Step invalid: " + this.StepperInfo[i - 1].name);
          }
        }
      }

      this.$store.dispatch("conversations/saveAnswers", {
        answers: Object.values(this.texts),
        isDone: true,
        conv: this.conv
      });
    },
    deleteConversation: function() {
      Swal.fire({
        title: "Est-ce que vous êtes sûr de vouloir sortir de la conversation?",
        text:
          "Les autres participants pourront continuer sans vous, et auront toujours accès à votre texte si il a été soumis. Vous ne pourrez plus rejoindre la conversation...",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Annuler",
        confirmButtonText: "Confirmer"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("conversations/removeUser", this.conv);
          this.$router.push({ name: "conversations" });
        }
      });
    }
  }
};
</script>

<style>
.question {
  padding: 10px;
  text-align: left;
}
.step-info {
  padding: 5px;
  padding-right: 15px;
}
.stepper-linear {
  padding-left: 0px !important;
  margin-left: -40px !important;
}
i {
  margin-right: 5px;
}
.stepper form {
  padding-right: 10px;
}
.answers {
  text-align: left;
}
.answer-question {
  color: grey;
}
</style>